import Classnames from 'classnames'
import { useAtom } from 'jotai'
import produce from 'immer'

// helper functions
import { returnBlockValue } from '@/utils/op-types/helperFunctions'
import Card from '@/components/optypes/frontend/StickyPage/blocks/Card'

// store
import {
  isBuilder,
  manifestStatic,
  pageContentStatic,
  manifestDesign,
  pageContentDesign,
  manifestBlocks,
  pageContentBlocks,
} from '@/utils/op-types/store'

const HeaderBlock = ({ id, block, design, content, index }) => {
  const [builder] = useAtom(isBuilder)
  // manifest settings
  const [opStatic] = useAtom(manifestStatic)
  const [opDesign] = useAtom(manifestDesign)
  const [opBlocks] = useAtom(manifestBlocks)
  // custom page settings
  const [pageStatic] = useAtom(pageContentStatic)
  const [pageDesign] = useAtom(pageContentDesign)
  const [pageBlocks] = useAtom(pageContentBlocks)

  return (
    <Card>
      <div
        className={Classnames('', {
          'border-l-4 pl-5 py-3':
            returnBlockValue(
              'bordertoggle',
              'design',
              opBlocks[block],
              design
            ) == 'showborder',
        })}
        style={{
          borderColor: returnBlockValue(
            'bordercolor',
            'design',
            opBlocks[block],
            design
          ),
        }}
      >
        <div
          className={Classnames('font-bold leading-normal', {
            'text-2xl':
              returnBlockValue(
                'headlinesize',
                'design',
                opBlocks[block],
                design
              ) == 'default',
            'text-3xl':
              returnBlockValue(
                'headlinesize',
                'design',
                opBlocks[block],
                design
              ) == 'xl',
            'text-4xl':
              returnBlockValue(
                'headlinesize',
                'design',
                opBlocks[block],
                design
              ) == '2xl',
          })}
        >
          {returnBlockValue('headline', 'content', opBlocks[block], content)}
        </div>
        <div
          className={Classnames('opacity-70 mt-1 leading-relaxed', {
            'text-md':
              returnBlockValue(
                'headlinesize',
                'design',
                opBlocks[block],
                design
              ) == 'default',
            'text-lg':
              returnBlockValue(
                'headlinesize',
                'design',
                opBlocks[block],
                design
              ) == 'xl',
            'text-xl':
              returnBlockValue(
                'headlinesize',
                'design',
                opBlocks[block],
                design
              ) == '2xl',
          })}
        >
          {returnBlockValue('subheadline', 'content', opBlocks[block], content)}
        </div>

        {returnBlockValue('copy', 'content', opBlocks[block], content) !=
          '' && (
          <div
            className="prose pt-4"
            dangerouslySetInnerHTML={{
              __html: returnBlockValue(
                'copy',
                'content',
                opBlocks[block],
                content
              ),
            }}
          ></div>
        )}
      </div>
    </Card>
  )
}

export default HeaderBlock
